import React, { useState, useEffect } from 'react';

// https://mobcup.net/ringtone/bloop-z35gr6uf
const song = require('./TaskComplete.mp3');

const Alarm = (props) => {
  const [inputValue, setInputValue] = useState('');
  const [alarms, setAlarms] = useState([]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const addAlarm = () => {
    const inputDate = new Date(inputValue);
    if (inputDate instanceof Date && !isNaN(inputDate)) {
      const currentTime = new Date();
      const timeDifference = inputDate - currentTime;
      console.log('timeDifference: ', timeDifference);
      if (timeDifference > 0) {
        setAlarms(prevAlarms => [...prevAlarms, { countdown: timeDifference, targetDate: inputDate }]);
      } else {
        alert('Please select a future date.');
      }
    } else {
      alert('Please enter a valid date.');
    }
  };

  const deleteAlarm = (index) => {
    setAlarms(prevAlarms => {
      const updatedAlarms = [...prevAlarms];
      updatedAlarms.splice(index, 1);
      return updatedAlarms;
    });
  };

  useEffect(() => {
    if (alarms.length > 0) {
      const timer = setInterval(() => {
        setAlarms(prevAlarms => {
          const updatedAlarms = prevAlarms.map((alarm, index) => {
            let newAlarm = {...alarm};
            console.log('alarm: ', alarm);
            if (newAlarm.countdown > 0) {
              // console.log('{ ...alarm, countdown: alarm.countdown - 1000 }: ', { ...alarm, countdown: alarm.countdown - 1000 });
              newAlarm = { ...newAlarm, countdown: newAlarm.countdown - 1000 };
            }
            if (newAlarm.countdown < 0) {
              console.log("inside PlaySong");
              playSong(); // Play the song when countdown reaches zero
              // console.log('{ ...alarm, countdown: -1 }: ', { ...alarm, countdown: 0 });
              newAlarm = { ...newAlarm, countdown: 0 }; // Set countdown to -1 to indicate that the song has been played
            }
            // console.log('alarm: ', alarm);
            console.log('newAlarm: ', newAlarm);
            return newAlarm;
          });
          return updatedAlarms.filter(alarm => alarm.countdown > 0); // Remove alarms with countdown -1 from the list
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [alarms]);

  const formatCountdown = (countdownTime) => {
    const days = Math.floor(countdownTime / (24 * 60 * 60 * 1000));
    const hours = Math.floor((countdownTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((countdownTime % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((countdownTime % (60 * 1000)) / 1000);

    return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
  };

  const playSong = () => {
    const audioElement = new Audio(song);
    audioElement.play();
  };

  return (
    <div>
      <input className='border' type="datetime-local" value={inputValue} onChange={handleInputChange} />
      <button className='border' onClick={addAlarm}>Add Alarm</button>
      {alarms.map((alarm, index) => (
        <div key={index} className='border'>
          {alarm.countdown <= 0 ? (
            <h3 className='border'>{props.title} Complete! Enjoy the song!</h3>
          ) : (
            <h3 className='border'>{props.title}: {formatCountdown(alarm.countdown)}</h3>
          )}
          <p>Target Date: {alarm.targetDate?.toLocaleString()}</p>
          <button className='border' onClick={() => deleteAlarm(index)}>Delete</button>
        </div>
      ))}
    </div>
  );
};

export default Alarm;
